//import { timpsSignalApp } from "./config";
import { versionInfo } from "../components/MainPage/VersionInfo";

export function tabTitle() {
  if (!versionInfo.loaded) {
    document.getElementById("tabTitle").innerHTML = "";
    return;
  }
  let timpsSignalApp = versionInfo.isSITE();
  let electricUtilApp = versionInfo.isEUtility();
  let liteApp = versionInfo.isReVAMP();
  let timpsApp = versionInfo.isTIMPS();
  document.getElementById("tabTitle").innerHTML = electricUtilApp
    ? "Electric Utility"
    : timpsSignalApp
      ? "SITE"
      : liteApp
        ? "ReVAMP"
        : timpsApp
          ? "TIMPS"
          : "TekTracking";
  //document.querySelector("link[rel~='icon']").href = './SCIM 1.png';
  //E:\lamp\LAMP\frontend\public\SCIM_Tab_Logo.png
  // document.getElementById("tabTitle").innerHTML = timpsSignalApp ?
  //   document.querySelector("link[rel~='icon']").href = '%PUBLIC_URL%/SCIM_Tab_Logo.png'
}



// WEBPACK FOOTER //
// ./src/config/tabConfig.js